// Profile pictures live at a stable URL (profile/{uid}), so the mobile WebView
// keeps serving the old bytes after someone replaces theirs. We append one
// cache-buster generated per app launch: within a session every avatar URL is
// stable (so it caches normally while you scroll), and the next launch uses a new
// value -- pulling the freshest picture for everyone, no matter which device
// changed it. Uploading your own reloads the app (see features/profile), which
// re-launches with a fresh buster too.

const CACHE_BUSTER = Date.now();

/** Append the per-launch cache-buster to a profile picture URL. */
export function bustProfileUrl(url: string): string {
  return `${url}&v=${CACHE_BUSTER}`;
}
